export const PREMIUM_PLAN_NAMES = [
    'Growing',
    'Pro',
    'Unlimited',
    'Farm',
    'Crescendo',
    'Profissional',
    'Ilimitado',
];

/** Planos com acesso de nível Pro (Farm Link, conciliação, vendas em lote). */
export const PRO_PLAN_NAMES = ['Pro', 'Unlimited', 'Farm', 'Profissional', 'Ilimitado'];

export const PREMIUM_PLAN_DISPLAY_NAMES = ['Crescendo', 'Profissional', 'Farm'];

const ADMIN_PLAN_CANONICAL = {
    free: 'Free',
    'começando': 'Free',
    comecando: 'Free',
    growing: 'Growing',
    crescendo: 'Growing',
    pro: 'Pro',
    profissional: 'Pro',
    unlimited: 'Unlimited',
    ilimitado: 'Unlimited',
    farm: 'Unlimited',
};

/** Normaliza aliases de plano (ex.: Crescendo) para valores do formulário admin. */
export function normalizeAdminPlanNames(planNames) {
    const seen = new Set();
    const out = [];
    for (const raw of planNames || []) {
        const key = String(raw || '').trim().toLowerCase();
        const canonical = ADMIN_PLAN_CANONICAL[key];
        if (canonical && !seen.has(canonical)) {
            seen.add(canonical);
            out.push(canonical);
        }
    }
    return out;
}

export function canonicalPlanName(planName) {
    const [canonical] = normalizeAdminPlanNames([planName]);
    if (canonical) {
        return canonical;
    }
    const trimmed = String(planName || '').trim();
    return trimmed || 'Free';
}

export function isSameSubscriptionPlan(planA, planB) {
    return canonicalPlanName(planA) === canonicalPlanName(planB);
}

export const PREMIUM_FEATURE_TOOLTIP =
    'Esta funcionalidade requer um plano pago.';

export function hasPremiumAccess(planName) {
    const canonical = canonicalPlanName(planName);
    return canonical === 'Growing' || canonical === 'Pro' || canonical === 'Unlimited';
}

/** Farm Link / integrações de impressora — plano Pro ou Farm. */
export function hasProAccess(planName) {
    const canonical = canonicalPlanName(planName);
    return canonical === 'Pro' || canonical === 'Unlimited';
}

/** Plano de destino é Pro / Profissional / Farm. */
export function isProSubscriptionPlan(plan) {
    return hasProAccess(plan?.name);
}

export function isUnlimitedSubscriptionPlan(plan) {
    return canonicalPlanName(plan?.name) === 'Unlimited';
}

export function publicPlanDisplayName(planName) {
    const canonical = canonicalPlanName(planName);
    const labels = {
        Free: 'Começando',
        Growing: 'Crescendo',
        Pro: 'Profissional',
        Unlimited: 'Farm',
    };
    return labels[canonical] || String(planName || '').trim() || 'Plano';
}

export function readStoredPlanName() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user.plan_name || 'Free';
    } catch {
        return 'Free';
    }
}

const PLAN_TIER_BY_CANONICAL = {
    Free: 100,
    Growing: 200,
    Pro: 300,
    Unlimited: 400,
};

export function planTierRank(planName, monthlyPrice = 0) {
    const canonical = canonicalPlanName(planName);
    if (PLAN_TIER_BY_CANONICAL[canonical] != null) {
        return PLAN_TIER_BY_CANONICAL[canonical];
    }
    const cents = Number(monthlyPrice) || 0;
    return cents > 0 ? 200 : 100;
}

/** @returns {'upgrade'|'downgrade'|null} */
export function comparePlanChange(currentPlanName, currentPrice, targetPlanName, targetPrice) {
    const currentTier = planTierRank(currentPlanName, currentPrice);
    const targetTier = planTierRank(targetPlanName, targetPrice);
    if (targetTier > currentTier) {
        return 'upgrade';
    }
    if (targetTier < currentTier) {
        return 'downgrade';
    }
    return null;
}

export function formatPlanRenewalDate(value) {
    if (!value) {
        return null;
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return null;
    }
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });
}
